import React from "react";
import { Typography, Stack, Box, Spacer, Divider } from "digiwash-components";
import { formatNumber } from "digiwash-core";
import { FormattedCartItemVariation } from "../../ducks/cart/cart-types";

function ServicesCounterChips(props: FormattedCartItemVariation) {
  return (
    <Box>
      <Stack>
        <Box p="m" bg="common.white" br="xm">
          <Stack>
            <Typography color="common.black">
              {formatNumber(props.quantity)}
            </Typography>
            <Spacer size="s" />
            <Typography color="primary.light970">|</Typography>
            <Spacer size="s" />
            <Typography numberOfLines={1} color="common.black">
              {props.name}
            </Typography>
          </Stack>
        </Box>
      </Stack>
      <Divider size="l" />
    </Box>
  );
}

export default ServicesCounterChips;
